import { makeStyles, shorthands } from "@fluentui/react-components";
import { BRAND } from "../risikoanalyseStep/tokens";

/**
 * Visual primitives shared by the Allgemein (generic) contract steps. Mirrors
 * the look & feel of the Immobilie / KFZ section components.
 */
export const useSharedStyles = makeStyles({
  cardSection: {
    display: "flex",
    flexDirection: "column",
    rowGap: "12px",
  },
  helper: {
    fontFamily: BRAND.fontPrimary,
    fontSize: "0.85rem",
    color: BRAND.muted,
  },
  blockTitle: {
    fontFamily: BRAND.fontAccent,
    fontSize: "1.1rem",
    color: BRAND.ink,
    margin: 0,
  },
  blockSub: {
    fontFamily: BRAND.fontPrimary,
    fontSize: "0.85rem",
    color: BRAND.muted,
  },
  // Yes/No tiles
  yesNoRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "10px",
    maxWidth: "380px",
  },
  ynTile: {
    cursor: "pointer",
    appearance: "none",
    backgroundColor: BRAND.white,
    backgroundImage: "none",
    color: BRAND.ink,
    fontFamily: BRAND.fontPrimary,
    fontSize: "0.95rem",
    fontWeight: 700,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    rowGap: "6px",
    paddingTop: "16px",
    paddingBottom: "16px",
    paddingLeft: "12px",
    paddingRight: "12px",
    minHeight: "72px",
    textAlign: "center",
    ...shorthands.borderRadius("10px"),
    ...shorthands.border("1.5px", "solid", BRAND.border),
    transitionProperty: "border-color, background-color, transform",
    transitionDuration: "140ms",
    ":hover": {
      ...shorthands.borderColor(BRAND.purple),
      transform: "translateY(-1px)",
    },
  },
  ynActiveYes: {
    backgroundColor: BRAND.pillarGreen,
    color: BRAND.white,
    ...shorthands.borderColor(BRAND.pillarGreen),
  },
  ynActiveNo: {
    backgroundColor: BRAND.purple,
    color: BRAND.white,
    ...shorthands.borderColor(BRAND.purple),
  },
  // Tile picker (Vertragsart / Versicherer / Tarifierung)
  tileRow: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "10px",
    "@media (min-width: 720px)": {
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    },
  },
  tileRow2: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "10px",
    "@media (min-width: 720px)": {
      gridTemplateColumns: "1fr 1fr",
    },
  },
  tile: {
    cursor: "pointer",
    appearance: "none",
    backgroundColor: BRAND.white,
    backgroundImage: "none",
    color: BRAND.ink,
    fontFamily: BRAND.fontPrimary,
    textAlign: "left",
    paddingTop: "14px",
    paddingBottom: "14px",
    paddingLeft: "16px",
    paddingRight: "16px",
    display: "flex",
    flexDirection: "column",
    rowGap: "4px",
    ...shorthands.border("1px", "solid", BRAND.borderDashed),
    ...shorthands.borderRadius("10px"),
    transitionProperty: "border-color, background-color",
    transitionDuration: "140ms",
    ":hover": { ...shorthands.borderColor(BRAND.purple), backgroundColor: "#f5eef6" },
    ":disabled": { cursor: "not-allowed", opacity: 0.45 },
  },
  tileActive: {
    ...shorthands.border("2px", "solid", BRAND.purple),
    backgroundColor: "#f5eef6",
    boxShadow: "0 4px 12px rgba(77,32,81,0.15)",
  },
  tileTitle: { fontWeight: 700, fontSize: "0.98rem", color: BRAND.ink },
  tileHint: { fontSize: "0.8rem", color: BRAND.muted },
  // Form fields
  fieldGrid: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "14px",
    "@media (min-width: 720px)": { gridTemplateColumns: "1fr 1fr" },
  },
  fieldGrid3: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "14px",
    "@media (min-width: 720px)": { gridTemplateColumns: "1fr 1fr 1fr" },
  },
  field: { display: "flex", flexDirection: "column", rowGap: "6px" },
  label: {
    fontSize: "0.72rem",
    fontWeight: 600,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: "#5d5664",
  },
  input: {
    boxSizing: "border-box",
    width: "100%",
    fontFamily: BRAND.fontPrimary,
    fontSize: "0.95rem",
    color: BRAND.ink,
    backgroundColor: BRAND.white,
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "12px",
    paddingRight: "12px",
    ...shorthands.border("1px", "solid", "#d4cfd9"),
    ...shorthands.borderRadius("8px"),
    outlineWidth: 0,
    ":focus": {
      ...shorthands.borderColor(BRAND.purple),
      boxShadow: `0 0 0 3px ${BRAND.purple}33`,
    },
  },
  textarea: { minHeight: "100px", resize: "vertical" },
  select: {
    appearance: "none",
    backgroundImage:
      "url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3e%3cpath fill='%235d5664' d='M6 8L0 0h12L6 8z'/%3e%3c/svg%3e\")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 12px center",
    paddingRight: "32px",
    cursor: "pointer",
  },
  hintBanner: {
    backgroundColor: "#fff5e6",
    color: "#7a4a10",
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "12px",
    paddingRight: "12px",
    fontSize: "0.88rem",
    ...shorthands.borderRadius("8px"),
    ...shorthands.border("1px", "solid", "#f3d4a3"),
  },
});
